export function noop(): undefined {
  return undefined;
}
